'use strict';

var getScrollbarDimensions = require('../lib/getScrollbarDimensions.js');

module.exports = function(makeVisible, element) {
	var element = element || document.documentElement;

	var modified = false;

	var scrollLocked = element.className.indexOf('lockScroll') !== -1;

	if (makeVisible) {
		if (scrollLocked) {
			element.className = element.className.replace(' lockScroll', '');
			element.style.paddingRight = '';
			modified = true;
		}
	} else {
		if (window.getComputedStyle(element, null).getPropertyValue('overflow-y') !== 'hidden') {
			element.className += ' lockScroll';

			var scrollbarDimensions = getScrollbarDimensions();
			if (scrollbarDimensions.width > 0) {
				element.style.paddingRight = scrollbarDimensions.width + 'px';
			}
			modified = true;
		}
	}

	return modified;
};